import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import CommentIcon from "@material-ui/icons/Comment";
import { FormOption } from "../ConfigForm";

export interface CheckboxListProps {
  options: FormOption[];
  selectedOptions: any[];
  onOptionClick: (id: string | number) => void;
}

export default function CheckboxList({
  options,
  selectedOptions,
  onOptionClick,
}: CheckboxListProps) {
  return (
    <List>
      {options.map((option) => {
        const labelId = `checkbox-list-label-${option.value}`;
        const checked = selectedOptions.includes(option.value);
        return (
          <ListItem key={option.value} role={undefined} dense button>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={checked}
                tabIndex={-1}
                onClick={() => {
                  onOptionClick(option.value);
                }}
                disableRipple
                inputProps={{ "aria-labelledby": labelId }}
              />
            </ListItemIcon>
            <ListItemText id={labelId} primary={option.label} />
          </ListItem>
        );
      })}
    </List>
  );
}
